import React, { useEffect, useRef, useState } from 'react';
import Icon from '../icon/Icon';
import './select.scss';
import { setAllModels, setStories } from '@/stores/slices/modelsState';
import Input from '../input/Input';
import { useDispatch, useSelector } from 'react-redux';
import { resetPage } from '@/stores/slices/modelsState';
import { useNavigate, useParams } from 'react-router-dom';
import {
	setCity,
	setCurrentCity,
	setUserCurrentDistrict,
	getUserCurrentDistrict,
	setTempCatalogueCity,
} from '@/stores/slices/userSlice';
import { clearTitle } from '@/stores/slices/titleSlice';
import useCityChange from '@/hooks/useCityChange';
import { getUserLang } from '@/stores/slices/userSlice';
import { showFilter } from '@/stores/slices/showFilterSlice';
import { setProfileCount } from '@/stores/slices/mapModelSlice';
import useLadyService from '@/services/LadyService';
import {
	getCountriesData,
	setCountry,
	setCountrySlug,
} from '../../../stores/slices/userSlice';
import { Dropdown } from '@/components/ui';
import { useFilterLogicContext } from '@/components/filter/FilterLogicProvider';
import { CityChangeSaveParams } from '@/components/filter/FilterData';

const SelectCountry = ({ ...props }) => {
	const {
		arrowSize,
		clazz,
		clazzSvg,
		clazzWrapper,
		name,
		setValue = undefined,
		onChange = false,
		paramsOnChange = false,
		defaultTitle = '',
		withoutIcon = false,
		withoutTitle,
		withoutArrow,
		setActive,
		setIsAddressActive,
		data,
		activeCountry,
		setActiveCountry = false,
		error,
		errorMessage,
		setError,
		isMain = false,
		open = false,
		disabled = false,
		placeholder,
		required,
		isAgencyFilter = false,
		selectCountry = true,
		changeParty = false,
		setWholeObjectValue,
		selectDistrict = false,
		deferApply = false, // When true, skip Redux dispatches; notify parent via onSelect
		onSelect = false,
	} = props;

	const transformedArray =
		data?.length > 0 &&
		data.flatMap((item) =>
			Object.entries(item).map(([code, { name }]) => ({ code, name })),
		);

	const FILTER = useFilterLogicContext();

	const { dispatch, t, scrollToTop } = useLadyService();
	const countriesData = useSelector(getCountriesData);
	const currentDistrict = useSelector(getUserCurrentDistrict);
	const { params: url_params } = useParams();

	const [localActiveCountry, setLocalActiveCountry] = useState(activeCountry);

	useEffect(() => {
		if (deferApply) {
			setLocalActiveCountry(null);
		}
	}, [activeCountry]);

	const effectiveActiveCountry =
		deferApply && localActiveCountry ? localActiveCountry : activeCountry;

	const toggleCountry = (code) => {
		if (data[0][code]) {
			const country = data[0][code];
			const slug = country.slug;
			const countryArray = [
				{
					id: country?.id ?? 1,
					title: country.name,
					icon: country.code.toUpperCase(),
					highlight: country?.highlight,
					slug: country.slug,
					profiles_count: country?.profiles_count ?? 0,
					sort: country.sort,
				},
			];

			if (deferApply) {
				setLocalActiveCountry(code);
				setIsOpen(false);

				if (setActiveCountry) {
					setActiveCountry(countryArray);
				}

				if (onSelect) {
					onSelect({
						type: 'country',
						data: countryArray,
						code: 'CZ',
						slug,
					});
				}
			} else {
				dispatch(setCountrySlug(slug));
				dispatch(setCountry(countryArray));
				setIsOpen(false);

				if (setActiveCountry) {
					setActiveCountry(countryArray);
				}

				if (isMain) {
					changeCity(slug);
					dispatch(setCurrentCity(countryArray[0]));
					dispatch(setUserCurrentDistrict({}));

					const safe_params =
						url_params && url_params !== 'undefined'
							? `/${url_params
									.split('-') // разбиваем по "-"
									.map((s) => s.trim()) // чистим пробелы
									.filter((s) => s.length > 0) // убираем пустые
									.filter((s) =>
										CityChangeSaveParams.includes(s),
									)
									.join('-')}`
							: '';

					if (!isFilterOpen) {
						dispatch(setUserCurrentDistrict({}));
						dispatch(resetPage());
						dispatch(setAllModels([]));
						dispatch(setStories([]));
						dispatch(setCity(slug));
						dispatch(setProfileCount(country.profiles_count));
						dispatch(clearTitle());
					}
					const params =
						lang === 'en' &&
						slug === 'czechia' &&
						safe_params === ''
							? '/'
							: `/${lang}/${slug}` + safe_params;
					FILTER.resetFilter(false, params, true);
				}

				scrollToTop();
			}
		}
	};

	let [title, setTitle] = useState('');
	let [paid, setPaid] = useState(null);

	const [code, setCode] = useState('CZ');

	let [searchVal, setSearchVal] = useState('');

	let [mainIcon, setMainIcon] = useState('CZ');

	const [isOpen, setIsOpen] = useState(false);
	useEffect(() => {
		setIsOpen(open);
	}, [open]);
	const selectRef = useRef(null);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleClickOutside = (event) => {
		if (selectRef.current && !selectRef.current.contains(event.target)) {
			setIsOpen(false);
			event.stopPropagation();
		}
	};

	const changeCity = useCityChange();
	const lang = useSelector(getUserLang);
	const isFilterOpen = useSelector(showFilter);

	function setValues(i, paramsOnChange, dist) {
		console.log(`=> set: `, i, dist);
		setTitle(`${i.name}${dist?.id ? ' ' + dist?.name : ''}`);
		console.log(`title: ${i.name}${dist?.id ? ' ' + dist?.name : ''}`);

		setPaid(i.price);
		setMainIcon(code);

		setMainIcon(effectiveActiveCountry); // use effective (local or prop)

		if (deferApply) {
			// ── Deferred: skip all dispatches, just notify parent ──
			if (onSelect) {
				onSelect({
					type: 'city',
					data: i,
					dist,
					countryCode: effectiveActiveCountry,
					slug: i.slug,
				});
			}
		} else {
			// ── Immediate: original dispatches ──
			dispatch(setTempCatalogueCity(false));
			dispatch(setCountrySlug(false));
		}

		if (isAgencyFilter) {
			return;
		}

		!!setValue && setValue(i.name);
		!!setWholeObjectValue && setWholeObjectValue(i);

		if (onChange) {
			if (paramsOnChange) {
				onChange(i, paramsOnChange);
			} else {
				onChange(i);
			}
		}

		if (!deferApply && (isMain || changeParty)) {
			changeCity(
				i.slug,
				i.districts.some((item) => item?.id === dist?.id) ? dist : null,
			);

			dispatch(
				setCurrentCity({
					id: i.id,
					title: i.name,
					icon: activeCountry,
					highlight: i.highlight,
					slug: i.slug,
					districts: i.districts,
				}),
			);

			if (i.districts.some((item) => item?.id === dist?.id)) {
				dispatch(setUserCurrentDistrict(dist));
			} else {
				dispatch(setUserCurrentDistrict({}));
			}

			const safe_params =
				url_params && url_params !== 'undefined'
					? `/${url_params
							.split('-') // разбиваем по "-"
							.map((s) => s.trim()) // чистим пробелы
							.filter((s) => s.length > 0) // убираем пустые
							.filter((s) => CityChangeSaveParams.includes(s))
							.join('-')}`
					: '';

			if (!isFilterOpen && !changeParty) {
				const params = `/${lang}/${i.slug}${
					i.districts.some((item) => item?.id === dist?.id)
						? `_${dist?.slug}` + safe_params
						: `` + safe_params
				}`;

				dispatch(resetPage());
				dispatch(setAllModels([]));
				dispatch(setStories([]));
				dispatch(setCity(i.slug));
				dispatch(setProfileCount(i.profiles_count));
				dispatch(clearTitle());
				FILTER.resetFilter(false, params, true);
			}
		}

		scrollToTop();
	}

	// useEffect(() => {
	// 	console.trace(`=> update: ${title}`);
	// }, [setTitle, title]);

	const handleClick = (i, e, dist = {}) => {
		e?.stopPropagation();
		// dispatch(setMassageState('empty'))

		if (setIsAddressActive) {
			setIsAddressActive(false);
		}
		if (setError) {
			setError('');
		}
		setValues(i, paramsOnChange, dist);
		setActive(i.id ?? 1);
		setIsOpen(false);
	};

	useEffect(() => {
		if (!selectCountry) {
			toggleCountry('cz');
			handleClick(searchedData[0]);
		}
	}, []);

	const searchedData = !!data?.length
		? data[0][effectiveActiveCountry?.toLowerCase()]?.cities.filter(
				(item) =>
					searchVal
						? item.name
								.toLowerCase()
								.includes(searchVal.toLowerCase())
						: item,
			)
		: [];

	useEffect(() => {
		console.log(`=> change of default title: `, defaultTitle);

		if (!searchedData || !defaultTitle) return;

		if (deferApply) {
			setTitle(defaultTitle);
		} else {
			setTitle(
				defaultTitle +
					(currentDistrict?.id ? ' ' + currentDistrict?.name : ''),
			);
		}

		const found = searchedData.find((i) => i.name === defaultTitle);
		if (found) {
			setPaid(found.price);
		}
	}, [defaultTitle]);

	if (!effectiveActiveCountry) {
		return;
	}

	if (!!searchedData?.length) {
		const highlightIndex = searchedData.findIndex(
			(item) => item.highlight === 2,
		);
		const highlightedItem = searchedData.splice(highlightIndex, 1)[0];

		searchedData.sort((a, b) => a.name.localeCompare(b.name));

		searchedData.unshift(highlightedItem);
	}

	const handleDist = (e, dist, i) => {
		e.stopPropagation();
		handleClick(i, e, dist);
	};

	const clickOpenHandler = () => {
		if (disabled) {
			return;
		} else {
			setIsOpen((prev) => !prev);
		}
	};

	return (
		<div
			className={`select-countries${required ? ' required' : ''}${
				isOpen ? ' select_active' : ''
			}${clazzWrapper ? ` ${clazzWrapper}` : ''}`}
			ref={selectRef}
		>
			<button
				title={paid ? `${t('adspublish')} ${t('ispaid')}` : ''}
				type={'button'}
				disabled={disabled}
				className={`${disabled ? '__disabled ' : ''}select__button${clazz ? ` ${clazz}` : ''}${clazzWrapper ? ` ${clazzWrapper}` : ''}`}
				onClick={clickOpenHandler}
			>
				{!withoutTitle && (
					<span
						className={
							`select__title` +
							(paid ? ' paid-city currency--erocoin' : '')
						}
					>
						{!withoutIcon ? (
							<Icon
								type={'flag'}
								spritePath={mainIcon}
								clazz={`select__icon${
									clazzSvg ? ` ${clazzSvg}` : ''
								}`}
							/>
						) : null}
						<span className="text-dots">
							{title !== '' ? title : (placeholder ?? '')}
						</span>
					</span>
				)}

				{!withoutArrow ? (
					<Icon
						clazz={'select__arrow'}
						size={arrowSize}
						spritePath={'chevrone-down'}
					/>
				) : null}

				{error && errorMessage}
			</button>

			<div
				className={`select__body`}
				onClick={(e) => e.stopPropagation()}
			>
				<div className="select__body-left">
					{!!transformedArray?.length &&
						transformedArray.map((i) => {
							return (
								<div
									onClick={() => {
										if (selectCountry)
											toggleCountry(i.code);
									}}
									className={`checkbox`}
									key={i.code}
								>
									<Icon
										type={'flag'}
										spritePath={i.code.toUpperCase()}
									/>
									<span>{i.name}</span>
								</div>
							);
						})}
				</div>

				<div className="select__body-right">
					<label
						htmlFor={`${name}-search`}
						className="select__search"
					>
						<Input
							type="search"
							placeholder={t('searchfield')}
							id={`${name}-search`}
							clazz={'search__input'}
							name={`${name}-search`}
							value={searchVal}
							setValue={setSearchVal}
						/>
					</label>

					<div className="dropdown__search-select">
						{!!data?.length && !!searchedData?.length ? (
							searchedData.map((i, index) => {
								return (
									<button
										key={index + 1}
										type={'button'}
										onClick={(e) => handleClick(i, e)}
										className={`select__item${
											i?.highlight === 2 ? ' fz-18' : ''
										}`}
									>
										{i.highlight === 2 ||
										i.highlight === 1 ? (
											<b
												className={
													!!i.price
														? 'paid-city currency--erocoin'
														: ''
												}
											>
												{i.title || i.name}
											</b>
										) : (
											<span
												className={
													!!i.price
														? 'paid-city currency--erocoin'
														: ''
												}
											>
												{i.title || i.name}
											</span>
										)}
										{/* districts select */}

										{i.districts.length > 0 &&
											selectDistrict && (
												<Dropdown
													title={
														currentDistrict?.name ? (
															<span>{`${
																i.title ||
																i.name
															} ${
																currentDistrict?.name
															}`}</span>
														) : (
															<span>
																{t('district')}
															</span>
														)
													}
													name={t('district')}
													size={'s'}
													hideOnCHange={true}
													clazzWrapper={` district-accordion ml-auto`}
													clazz={
														' _no-arrow select_district'
													}
													// openOnHover={true}
												>
													{i.districts.map(
														(dist, idx) => {
															return (
																<span
																	style={{
																		fontSize:
																			'15px',
																	}}
																	className="hover-line"
																	key={
																		i.name +
																		idx
																	}
																	onClick={(
																		e,
																	) => {
																		handleDist(
																			e,
																			dist,
																			i,
																		);
																	}}
																>
																	{`${
																		i.title ||
																		i.name
																	} ${dist.name}`}
																</span>
															);
														},
													)}
												</Dropdown>
											)}
									</button>
								);
							})
						) : (
							<>{t('nosearchcountry')}</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default SelectCountry;

export const useToggleCountryCZ = () => {
	const dispatch = useDispatch();
	const countriesData = useSelector(getCountriesData);
	const changeCity = useCityChange();

	const toggleCountry = () => {
		if (countriesData[0]['cz']) {
			const country = countriesData[0]['cz'];
			const slug = country.slug;
			const countryArray = [
				{
					id: country?.id ?? 1,
					title: country.name,
					icon: country.code.toUpperCase(),
					highlight: country?.highlight,
					slug: country.slug,
					profiles_count: country?.profiles_count ?? 0,
					sort: country.sort,
				},
			];
			dispatch(setCountrySlug(slug));
			dispatch(setCountry(countryArray));
			dispatch(setCity(slug));
			changeCity(slug);
			dispatch(setCurrentCity(countryArray[0]));
			dispatch(setUserCurrentDistrict({}));
			// resetFilter(false);
		}
	};

	return toggleCountry;
};
